import { useCallback } from "react";
import { useAtomCallback } from "jotai/utils";
import {
  serviceAtomFamily,
  Implementation,
  servicesAtomReadOnly,
} from "@zapier/canvas-state";
import { useAtomValue } from "jotai";

type ReturnType = (appId: string) => Implementation | undefined;

export default function useServiceById(): ReturnType {
  const services = useAtomValue(servicesAtomReadOnly);
  return useAtomCallback(
    useCallback(
      (get, _set, appId: string) => get(serviceAtomFamily(appId)),

      // We need services or else we won't get the latest service by id
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [services],
    ),
  );
}
